export default "__VITE_ASSET__c7dbfb77__"